/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Tue Dec 18 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class SessionSetupController {
    constructor($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
        "ngInject"
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Session Setup"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        let self = this

        this.reset = () => {
            this.isEdit = false;
            this.errors = {};
            this.sessionAvailablility = null;
            self.session = {}
            _.defer(function () {
                $scope.$apply();
            });
        }

        $scope.getList = function (schoolId) {
            self.reset()
            authService.callAPI("/v0/school/details/" + schoolId + "/session", "GET", null, function (response) {
                try {
                    $scope.session = response.result.data.data
                } catch (e) {
                    $scope.session = []
                }
                $scope.$apply()
            })
        }

        let schoolId = localStorageService.get('school_id')
        $scope.getList(schoolId)

        self.saveSession = () => {
            this.errors = {}
            if(!self.session){
                toastr.error("Name is required")
                return false
            }
            if(!self.session.name){
                toastr.error("Name is required")
                return false
            }
            if(!self.session.start_time){
                toastr.error("Starttime is required")
                return false
            }
            if(!self.session.end_time){
                toastr.error("Endtime is required")
                return false
            }
            let session = self.session
            $scope.loading = true

            let requestBody = {
                school_id: schoolId,
                session_name: session.name,
                start_time: session.start_time,
                end_time: session.end_time
            }

            var method = "POST"
            var message = "Session saved successfully"
            if (this.isEdit) {
                method = "PUT"
                requestBody.session_id = session._id
                message = "Session updated successfully"
            }
            authService.callAPI("/v0/utilities/session/setup", method, requestBody, function (response) {
                if (response && response.result) {
                    toastr.success(message);
                    $scope.loading = false
                    $scope.getList(schoolId)
                    self.session = {}
                    self.reset()
                } else {
                    let error = response.error
                    try {
                        toastr.error(error.error.message);
                    } catch (ex) {
                        toastr.error(error);
                    }
                }
            })

        }

        self.editSession = (session) => {
            self.focusMe = true;
            this.isEdit = true;
            this.oldSession = session.name
            self.session = angular.copy(session);
        }

        self.removeSession = (curId) => {
            var requestBody = {
                school_id: schoolId,
                session_id: curId
            }
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete the session?')
                .textContent('')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                $scope.loading = true
                authService.callAPI("/v0/utilities/session/setup", "DELETE", requestBody, function (response) {
                    if (response && response.result) {
                        $scope.getList(schoolId)
                        $scope.loading = false
                        self.session = undefined;
                        self.isEdit = false
                        toastr.success('Successfully removed!');
                    } else {
                        let error = response.error
                        try {
                            toastr.error(error.error.message);
                            $scope.loading = false
                        } catch (ex) {
                            toastr.error(error);
                        }
                    }
                })
            });
        }

        this.openMenu = function ($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        };

        this.$onDestroy = () => {

        }
    }
}

export default SessionSetupController;



// WEBPACK FOOTER //
// ./src/app/utilities/sessionSetup/controllers/sessionSetupController.js